import { ref } from "vue"

export type PopupNovo = {
    id: number
    imagem_desktop: string
    imagem_mobile: string
    link: string
    nova_janela: boolean    

    empresa: string
    
    areas: string[]
}



import popup1_desktop from '~/images/popup/desktop.jpg'
import popup1_mobile from '~/images/popup/mobile.jpg'

import popup2_mobile from '~/images/popup/favoritos_mobile.png'

import popup3_desktop from '~/images/popup/easy/apresentacao_desktop.png'
import popup3_mobile from '~/images/popup/easy/apresentacao_mobile.png'

import popup4_desktop from '~/images/popup/easy/favoritos_desktop.png'
import popup4_mobile from '~/images/popup/easy/favoritos_mobile.png'

import { empresa } from "../empresas"

export const popups_visualizados = ref<number[]>(JSON.parse(localStorage.getItem('popup-novos-visualizados')||'[]')||[])

const default_rows: PopupNovo[] = [
    {
        id: 1,
        imagem_desktop: popup1_desktop,
        imagem_mobile: popup1_mobile,
        link: '',
        nova_janela: true,
        empresa: 'Vila Rica',
        areas: ['home']
    },
    {
        id: 2,
        imagem_desktop: popup2_mobile,
        imagem_mobile: popup2_mobile,
        link: '',
        nova_janela: true,
        empresa: 'Vila Rica',
        areas: ['menu']
    },
    {
        id: 3,
        imagem_desktop: popup3_desktop,
        imagem_mobile: popup3_mobile,
        link: '',
        nova_janela: true,
        empresa: 'São Luiz',
        areas: ['home']
    },
    {
        id: 4,
        imagem_desktop: popup4_desktop,
        imagem_mobile: popup4_mobile,
        link: '',
        nova_janela: true,
        empresa: 'São Luiz',
        areas: ['menu']
    },
].filter(row => {
    
    if (row.empresa != empresa.title) {
        return false
    }
    return true
})

export const popups_novos = ref<PopupNovo[]>(default_rows)